<template>
   <van-calendar
   ref="calendar"
              title=" "
              :poppable="false"
              :show-confirm="false"
              :show-title="false"
              :show-subtitle="false"
              :row-height="40"
              :min-date="minDate"
              :max-date="maxDate"
              :default-date="today"
              lazy-render
              :style="{ height: '200px' }"
   />
</template>

<script>
export default {
    data() {
        return {
            minDate: new Date(2025, 0, 1),
            maxDate: new Date(2025, 12, 31),
            today: new Date(), // 设置当前日期
        }
    },
    methods: {

    },
    mounted() {
         // 如果需要进行其他操作，比如滚动到今天，可以在这里进行
    this.$nextTick(() => {
         this.$refs.calendar.scrollToDate()
      // 如果需要对日历做进一步操作，利用 this.$refs 可以访问组件的方法
      // 例如 this.$refs.calendar.scrollToToday()，如果有相关的API方法
    });
        
    },
    components: {
    },
    props: {
    },


}
</script>

<style lang="less" scoped>
.van-calendar {
}
::v-deep .van-calendar__header{
    box-shadow:none;
}
::v-deep .van-calendar__header-title{
    display: none;
}
::v-deep .van-calendar__header-subtitle{
    display: none;
}

</style>